import { render, staticRenderFns } from "./mzj_Recommend.vue?vue&type=template&id=a42c492a&scoped=true&"
import script from "./mzj_Recommend.vue?vue&type=script&lang=js&"
export * from "./mzj_Recommend.vue?vue&type=script&lang=js&"
import style0 from "./mzj_Recommend.vue?vue&type=style&index=0&id=a42c492a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a42c492a",
  null
  
)

export default component.exports